import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {backgroundGray, black, marketingMobileCuttoff} from "@css/constants";
import {backgroundImageStyle, fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";

export const FeaturedSectionContainer = styled('div')(css`
  flex-direction: column;
  display: flex;
  height: 290px;
  background-color: ${backgroundGray};

  @media(max-width: ${marketingMobileCuttoff}) {
    max-height: 250px;
    padding-bottom: 20px;
  }
`)

type FeaturedSectionImageProps = {
  src: string;
}

export const FeaturedSectionImage = styled.div<FeaturedSectionImageProps>`
  flex-direction: column;
  display: flex;
  height: 212px;
  background-image: url(${props => props.src});
  ${backgroundImageStyle};
`;

export const FeaturedSectionText = styled('div')(css`
  ${fontSize(20)};
  ${FontNormal(700)};
  color: ${black};
  font-family: Averta PE;
  align-self: center;
  text-align: center;
  margin-top: 40px;
  padding-left: 20px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    padding-left: 0;
    width: 90%;
  }
`)
